import { createHttpClient } from '@adapters/HttpClient';
import { PaymentMethodsApiAdapter } from '@modules/Orders/List/adapters/PaymentMethodsApiAdapter';
import { ShopsApiAdapter } from '@modules/Orders/List/adapters/ShopsApiAdapter';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const paymentMethodsAdapter = new PaymentMethodsApiAdapter(httpClient);
const shopsAdapter = new ShopsApiAdapter(httpClient);

export function useProfitabilitySummaryOrdersFilterOptions(enabled: boolean) {
  const shops = useQuery({
    queryKey: ['profitability', 'summary-orders-filter', 'shops'],
    queryFn: () => shopsAdapter.getAll(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  const paymentMethods = useQuery({
    queryKey: ['profitability', 'summary-orders-filter', 'payment-methods'],
    queryFn: () => paymentMethodsAdapter.getAll(),
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  const shipmentStatuses = useQuery({
    queryKey: ['profitability', 'summary-orders-filter', 'shipment-statuses'],
    queryFn: async () => {
      const raw = await httpClient.get<{ data?: unknown[] } | unknown[]>('/shipment-statuses');
      const list = Array.isArray(raw) ? raw : (raw?.data ?? []);
      return list.map((item) => {
        const s = item as { id: number; name?: string; description?: string };
        return {
          id: s.id,
          name: s.name || s.description || String(s.id),
        };
      });
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return { shops, paymentMethods, shipmentStatuses };
}
